import React from "react"
import { Helmet } from "react-helmet"
import { getServerSideURL } from "../../utils/get-url"

const ArticleData = ({
  title,
  author,
  date,
  articleDataImage,
  description,
  pathname,
}) => {
  const baseUrl = getServerSideURL();

  return (
  <Helmet>
    <script type="application/ld+json">
      {`
        {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "${baseUrl}${pathname}",
            "name": "${title}"
          },
          "headline": "${title}",
          "image": [
            "${baseUrl}${articleDataImage}"
          ],
          "datePublished": "${date}",
          "author": {
            "@type": "Person",
            "name": "${author}"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Iliad Epic Grow"
          },
          "description": "${description}"
        }
      `}
    </script>
  </Helmet>
)}

export default ArticleData
